import { useState, useEffect, useCallback } from 'react';
import { useFPS } from './useFPS';

const FPS_STORAGE_KEY = 'storage-ui-show-fps';

export const useFPSControl = () => {
  // FPS counter state with localStorage persistence
  const [showFPS, setShowFPS] = useState<boolean>(() => {
    const saved = localStorage.getItem(FPS_STORAGE_KEY);
    return saved === 'true';
  });

  // Save FPS visibility to localStorage
  useEffect(() => {
    localStorage.setItem(FPS_STORAGE_KEY, showFPS.toString());
  }, [showFPS]);

  // FPS counter hook - tracks rendering performance
  const fps = useFPS(showFPS);

  // Toggle function
  const toggleFPS = useCallback(() => {
    setShowFPS(prev => !prev);
  }, []);

  return {
    showFPS,
    toggleFPS,
    fps,
  };
};
